<div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-all-service-tab">
  <div class="my-services">
    <!-- card -->
    <ng-container *ngIf="myServices.length > 0">
      <div class="my-services__card" *ngFor="let row of myServices | paginate: paginator; index as i">
        <div class="image-section">
          <div class="custom-checkbox custom-webkit--translate">
							<input class="styled-checkbox select-item orders_inputAll" id="product-styled-checkbox-{{i}}" type="checkbox" (click)="toggleSelect(row[selectKey], row)" [checked]="selected.includes(row[selectKey])">
              <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
              </svg>
              <svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
                  <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </div>
          <img appLazyLoad="{{ row.service_image }}" loading="lazy" alt="{{ row.name }}">
        </div>
        <div class="content-section">
          <div class="my-services__card--top">
            <div class="left-item">
              <span class="name">{{ row.category }} <span *ngIf="row.category_ar">({{ row.category_ar }})</span></span>
              <span class="description">{{ row.name }} <span *ngIf="row.name_ar">({{ row.name_ar }})</span></span>
            </div>
            <div class="right-item">
              <div class="new-create-switch">
                <div class="switch-wrapper">
                  <div class="switch">
                    <input type="checkbox" id="auto-renew" name="auto-renew" [checked]="row.active" (click)="showHideService(row)">
                    <span class="slider round"></span>
                  </div>
                </div>
              </div>
              <span class="id-num">
                <ng-container>ID</ng-container>:
                {{ row.service_number }}
              </span>
              <div class="price-section">
                <div class="price-section--price" i18n="@@services.price">Price:</div>
                <!-- السعر : -->
                <div class="price-section--amount">
                  <span class="sar-cur" [innerHtml]="basicInfo?.currency_symbol"></span> 
                  {{ row.price }}
                </div>
              </div>
            </div>
            
          </div>
          <div class="my-services__card--main pre-text">{{ row.description | titlecase }}</div>
          <div class="my-services__card--main pre-text">{{ row.description_ar | titlecase }}</div>
          <div class="dropdown more-items" ngbDropdown container="body" placement="bottom-right">
            <a ngbDropdownToggle href="javascript:void(0)" >
              <svg width="18" height="5" viewBox="0 0 18 5">
                <path fill-rule="evenodd" d="M2.143 0c1.183 0 2.143.96 2.143 2.143 0 1.183-.96 2.143-2.143 2.143C.959 4.286 0 3.326 0 2.143 0 .959.96 0 2.143 0zM9 0c1.183 0 2.143.96 2.143 2.143 0 1.183-.96 2.143-2.143 2.143-1.183 0-2.143-.96-2.143-2.143C6.857.959 7.817 0 9 0zm6.857 0C17.041 0 18 .96 18 2.143c0 1.183-.96 2.143-2.143 2.143-1.183 0-2.143-.96-2.143-2.143 0-1.184.96-2.143 2.143-2.143z"/>
              </svg>
            </a>
            <div ngbDropdownMenu class="dropdown-menu-left" aria-labelledby="dropdownBasic1">
              <div ngbDropdownItem class="cursor-pointer" i18n="@@products.edit" (click)="editService(row)">Edit</div>
              <div ngbDropdownItem class="cursor-pointer" i18n="@@products.delete" (click)="onDelete.emit(row)">Delete</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- end card -->

  </div>
</div>
